import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { HeaderNavComponent } from './components/header-nav/header-nav.component';
import { HeaderComponent } from './header.component';


@NgModule({
    imports: [
        CommonModule,
        AccountSharedModule,
        UIRouterModule.forChild({})
    ],
    declarations: [
        HeaderComponent,
        HeaderNavComponent
    ],
    exports: [
        HeaderComponent,
        HeaderNavComponent
    ]
})
export class HeaderModule {

}
